import { useConfig } from "@/context/ConfigContext";
import { useQuery } from "@tanstack/react-query";

export function usePages(options = {}) {
  const { slug, enabled = true, onlyMenu = false } = options;
  const { isConfigReady } = useConfig();

  const hasSingle = !!slug;
  const queryEnabled = enabled && isConfigReady;

  const queryKey = hasSingle
    ? ["page-v2", slug]
    : ["pages-v2", { onlyMenu }];

  const { data, isLoading, error } = useQuery({
    queryKey,
    enabled: queryEnabled,
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
    queryFn: async () => {
      const url = slug
        ? `/api/pages/${encodeURIComponent(slug)}`
        : `/api/pages`;

      const res = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        cache: "no-cache",
      });

      if (!res.ok) {
        let msg = res.statusText;
        try {
          const j = await res.json();
          msg = j?.message || msg;
        } catch { /* ignore */ }
        throw new Error(msg || "Gagal mengambil pages");
      }

      const json = await res.json();
      const rawData = json?.data;

      if (slug) {
        return rawData || null;
      }

      const list = Array.isArray(rawData) ? rawData : [];
      const normalized = onlyMenu ? list.filter((p) => p?.show_in_menu) : list;
      return [...normalized].sort((a, b) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0));
    },
  });

  return {
    pages: hasSingle ? null : (Array.isArray(data) ? data : []),
    page: hasSingle ? data || null : null,
    loading: queryEnabled ? isLoading : false,
    error: error ? error.message || "Gagal mengambil pages" : null,
  };
}
